import React, { useEffect } from "react";
import { Container } from "components/shared";
import { IconButton } from "components/components/atoms";
import getMapLink from "utils/getMapLink";
import { getFieldValue } from "@sitecore-jss/sitecore-jss-react";
import CallIcon from "components/icons/Call";
import { useUiValue, openRegistrationModal } from "stores/uiContext";
import { track } from "utils/tracking";
import trackingEvents from "utils/trackingEvents";

const AnchorCTA = ({ fields }) => {
  const firstAddress = getFieldValue(fields, "firstAddress");
  const secondAddress = getFieldValue(fields, "secondAddress");
  const latitude = getFieldValue(fields, "latitude");
  const longitude = getFieldValue(fields, "longitude");
  const state = fields.state;
  const city = fields.city;
  const zipcode = fields.zipcode;
  const phoneNumberCall = getFieldValue(fields, "phoneNumberCall");
  const gmbLink = fields.gmbLink;

  const [_, dispatch] = useUiValue();

  const handleCalendarClick = () => {
    window.dataLayer.push({ event: "email" });
    dispatch(openRegistrationModal());
  };

  useEffect(() => {
    var chatBoxDiv = document.getElementById("drift-frame-controller");
    if (chatBoxDiv) {
      chatBoxDiv.style.bottom = "5.2rem";
    }
  });

  return (
    <div
      id="anchor-cta"
      className="block lg:hidden bg-light-blue fixed w-screen bottom-0 left-0 z-40"
    >
      <Container className="px-2">
        <div className="flex items-center justify-between px-6 py-4">
          <IconButton
            className={
              "md:flex transition-opacity duration-200 text-light-blue"
            }
            icon="schedule"
            color="blue"
            circled
            small
            onClick={handleCalendarClick}
            buttonLabel={"Schedule Appointment"}
          />
          <a
            href={`tel:${phoneNumberCall}`}
            onClick={() => {
              track({ eventId: trackingEvents.ClickToCall });
              window.dataLayer.push({ event: "telephone-number" });
            }}
            aria-label={"Call to " + phoneNumberCall}
          >
            <CallIcon className="h-10 w-10 text-action-blue rounded-full" />
          </a>
          <a
            href={
              gmbLink && gmbLink.href
                ? gmbLink.href
                : latitude && longitude
                ? getMapLink(latitude + "," + longitude)
                : getMapLink(
                    firstAddress +
                      " " +
                      secondAddress +
                      " " +
                      city +
                      " " +
                      state +
                      " " +
                      zipcode
                  )
            }
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => {
              track({ eventId: trackingEvents.DrivingDirections });
              window.dataLayer.push({ event: "google-map" });
            }}
            aria-label={
              "Go to " +
              firstAddress +
              " " +
              secondAddress +
              " " +
              city +
              " " +
              state +
              " " +
              zipcode +
              ". Opens in GoogleMaps"
            }
          >
            <IconButton
              className={
                "md:flex transition-opacity duration-200 text-light-blue"
              }
              buttonLabel={"Show map location"}
              icon="mapmarker"
              color="blue"
              circled
              small
            />
          </a>
        </div>
      </Container>
    </div>
  );
};

export default AnchorCTA;
